let btnAttr = 'data-component-code';
let inFavoritesClass = 'favorite-btn--in-favorites';

$('body').on('click', '['+btnAttr+']', function(){
	
	var $el = $(this);
	let componentCode = $el.attr(btnAttr);
	
	$.ajax({
		url: '/favorites/',
		method: 'get',
		dataType: "json",
		data: {
			'add_favorites': componentCode,
		},
		success: function (data) {
			if (!data.status) {
				console.log("Запрос выполнился неудачно. Подробности в системе логирования");
			}
		},
	}).done(function(){
		if($el.hasClass(inFavoritesClass)) {
			$el.removeClass(inFavoritesClass);
		}else{
			$el.addClass(inFavoritesClass);
		}
	});
	
});